module.exports = __webpack_public_path__ + "images/emoji/kissing_smiling_eyes.03c7b9a21ab73ca487d4.png";